import { useState } from "react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useAdminStatus } from "@/hooks/useAdminStatus";
import { resolveSidebarCollapsed } from "@/hooks/use-laptop-sidebar";
import { SidebarContent } from "./sidebar/SidebarContent";
import { cn } from "@/lib/utils";

interface SidebarProps {
  setIsMenuOpen: (value: boolean) => void;
}

/**
 * Sidebar.
 */
export function Sidebar({ setIsMenuOpen }: Readonly<SidebarProps>) {
  const { isAdmin } = useAdminStatus();
  const [userCollapsed, setUserCollapsed] = useState<boolean | null>(null);
  const isCollapsed = resolveSidebarCollapsed(userCollapsed);

  const toggleSidebar = () => setUserCollapsed(!isCollapsed);

  return (
    <>
      {/* Mobile Sidebar - Hidden, hamburger now in header */}
      <div className="hidden">
        <Sheet>
          <SheetTrigger asChild>
            <Button className="hidden" />
          </SheetTrigger>
          <SheetContent
            side="left"
            className="w-[320px] p-0 bg-background border-border sm:hidden overflow-y-auto flex flex-col max-h-screen"
          >
            <SheetTitle className="sr-only">Navigation menu</SheetTitle>
            <SidebarContent
              pathname=""
              isAdmin={isAdmin}
              isCollapsed={false}
              toggleSidebar={toggleSidebar}
              setIsMenuOpen={setIsMenuOpen}
              isMobile={true}
            />
          </SheetContent>
        </Sheet>
      </div>

      {/* Desktop Sidebar - Full height, smooth transitions */}
      <div
        className={cn(
          "hidden sm:flex min-h-screen sticky top-0 flex-shrink-0 bg-background border-r border-border flex-col",
          "transition-all duration-300 ease-in-out",
          isCollapsed ? "w-16" : "w-64"
        )}
      >
        <SidebarContent
          pathname=""
          isAdmin={isAdmin}
          isCollapsed={isCollapsed}
          toggleSidebar={toggleSidebar}
          setIsMenuOpen={setIsMenuOpen}
          isMobile={false}
        />
      </div>
    </>
  );
}
